"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormControlLabelOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginLeft: spacing(-1),
            marginRight: spacing(3),
        },
        label: {
            ".MuiCheckbox-root + &, .MuiRadio-root + &": {
                marginLeft: spacing(2),
            },
        },
    });
};
//# sourceMappingURL=MuiFormControlLabel.js.map